(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 10545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(82886);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/AuthPageHeader.jsx
var AuthPageHeader = __webpack_require__(52696);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/AuthPagePaper.jsx
var AuthPagePaper = __webpack_require__(55474);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/AuthPageFooter.jsx
var AuthPageFooter = __webpack_require__(97360);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/platform/views/Auth/components/ThirdPartyBox.jsx


var ThirdPartyBox = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "ThirdPartyBox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiAlertTriangle */.BJv, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "We've detected that your browser does not have third-party cookies enabled. The Demyst platform uses third-party cookies to maintain your secure session. For optimal performance, please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://akohubteam.medium.com/how-to-enable-third-party-cookies-on-your-browsers-f9a8143b8cc5",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "enable third-party cookies"
                    }),
                    " ",
                    "or change browsers."
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./src/platform/components/MessageBox/MessageBox.jsx
var MessageBox = __webpack_require__(43454);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./src/redux/user/userSlice.js
var userSlice = __webpack_require__(44372);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./src/platform/components/Loader/Loader.jsx
var Loader = __webpack_require__(5786);
// EXTERNAL MODULE: ./src/redux/user/userSelectors.js
var userSelectors = __webpack_require__(74918);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./src/utils/serializeError.js
var serializeError = __webpack_require__(99584);
// EXTERNAL MODULE: ./src/utils/createTestId.js
var createTestId = __webpack_require__(6282);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/UserUnlockedBox.jsx
var UserUnlockedBox = __webpack_require__(27832);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/input_field/index.jsx
var input_field = __webpack_require__(71493);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/button/index.jsx
var ui_button = __webpack_require__(58278);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/platform/views/Auth/Login.jsx





























var Login = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(true), allowsThirdPartyCookie = ref1[0], setAllowsThirdPartyCookie = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), showPassword = ref3[0], setShowPassword = ref3[1];
    var isUserLoggedIn = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.isUserLoggedIn */.p.isUserLoggedIn);
    var isUserDataFetching = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.isUserDataFetching */.p.isUserDataFetching);
    var lastLoggedOutPage = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.lastLoggedOutPage */.p.lastLoggedOutPage);
    var ref4 = (0,react.useState)(false), isCaptchaRequired = ref4[0], setIsCaptchaRequired = ref4[1];
    var ref5 = (0,react.useState)(null), captchaResponse = ref5[0], setCaptchaResponse = ref5[1];
    var recaptchaRef = (0,react.useRef)();
    var onCaptchaChange = function(captchaResponse) {
        setCaptchaResponse(captchaResponse);
    };
    var checkIfCaptchaIsRequired = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, next_submit_requires_captcha;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return userApi/* userApi.isLoginCaptchaNeeded */.B.isLoginCaptchaNeeded();
                    case 3:
                        ref = _ctx.sent;
                        next_submit_requires_captcha = ref.data.next_submit_requires_captcha;
                        if (next_submit_requires_captcha) {
                            setIsCaptchaRequired(true);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function checkIfCaptchaIsRequired() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var form, email, password, code, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        setError(null);
                        setLoading(true);
                        form = new FormData(event.target);
                        email = form.get("email");
                        password = form.get("password");
                        code = form.get("code");
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return userApi/* userApi.login */.B.login(email, password, code, captchaResponse);
                    case 10:
                        data = _ctx.sent.data;
                        dispatch(userSlice/* userActions.setUserData */.hI.setUserData({
                            userData: data
                        }));
                        (0,userTracking/* sendGaEvent */.k8)({
                            action: "Log In Success",
                            category: "Log In"
                        }, email);
                        _ctx.next = 21;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](7);
                        setError((0,serializeError/* serializeError */.X)(_ctx.t0));
                        (0,userTracking/* sendGaEvent */.k8)({
                            action: "Log In Invalid",
                            category: "Log In"
                        }, email);
                        _ctx.next = 21;
                        return checkIfCaptchaIsRequired();
                    case 21:
                        _ctx.prev = 21;
                        setLoading(false);
                        return _ctx.finish(21);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    15,
                    21,
                    24
                ]
            ]);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePasswordToggle = function(e, state) {
        e.preventDefault();
        setShowPassword(state);
    };
    (0,react.useEffect)(function() {
        checkIfCaptchaIsRequired();
    }, []);
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!isUserLoggedIn && !isUserDataFetching)) {
                                _ctx.next = 3;
                                break;
                            }
                            _ctx.next = 3;
                            return dispatch(userSlice/* userThunks.fetchUserData */.Dw.fetchUserData({
                                loginType: "PLATFORM"
                            }));
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            setLoading(false);
        };
    }, []);
    (0,react.useEffect)(function() {
        var checkCookies = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var thirdPartyCookieAllowed;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return userApi/* userApi.checkThirdPartyCookie */.B.checkThirdPartyCookie();
                        case 2:
                            thirdPartyCookieAllowed = _ctx.sent;
                            setAllowsThirdPartyCookie(thirdPartyCookieAllowed);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function checkCookies() {
                return _ref.apply(this, arguments);
            };
        }();
        checkCookies();
    }, []);
    (0,react.useEffect)(function() {
        if (!isUserDataFetching) {
            var ref;
            (ref = document.getElementById("email")) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        isUserDataFetching
    ]);
    (0,react.useEffect)(function() {
        if (error !== null && typeof recaptchaRef.current !== "undefined") {
            recaptchaRef.current.reset();
        }
    }, [
        error
    ]);
    if (isUserLoggedIn) {
        var ref6, ref7;
        router.push({
            pathname: ((ref6 = window.location.state) === null || ref6 === void 0 ? void 0 : ref6.redirectTo.pathname) || lastLoggedOutPage || linksConstants/* linksConstants.PLATFORM_HOME */.s.PLATFORM_HOME,
            search: (ref7 = window.location.state) === null || ref7 === void 0 ? void 0 : ref7.redirectTo.search
        });
    }
    if (isUserDataFetching) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        role: "main",
        className: "Login",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Login__header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPageHeader/* AuthPageHeader */.w, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Login__paper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthPagePaper/* AuthPagePaper */.v, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                "data-test-id": (0,createTestId/* createTestId */.z)("loginPageHeader"),
                                className: "Login__paper__header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "Login__paper__header__title",
                                    children: "Log in to your account"
                                })
                            }),
                            /*location.state?.userUnlocked (TODO: Researh about location state and next router)*/  false && /*#__PURE__*/ 0,
                            !allowsThirdPartyCookie && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdPartyBox, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "LoginForm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_field/* default */.Z, {
                                        size: "regular",
                                        type: "email",
                                        name: "email",
                                        label: "Email",
                                        id: "email",
                                        autoComplete: "username",
                                        required: true,
                                        className: "emailInput"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_field/* default */.Z, {
                                        className: "LoginForm__password",
                                        size: "regular",
                                        type: showPassword ? "text" : "password",
                                        name: "password",
                                        label: "Password",
                                        id: "password",
                                        autoComplete: "current-password",
                                        required: true,
                                        rightIconSrc: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "LoginForm__toggleButton",
                                            onClick: function(e) {
                                                return handlePasswordToggle(e, false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiEyeOff */.rzC, {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "LoginForm__toggleButton",
                                            onClick: function(e) {
                                                return handlePasswordToggle(e, true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiEye */.rDJ, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "LoginForm__forgotPasswordLink",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: linksConstants/* linksConstants.FORGOT_PASSWORD */.s.FORGOT_PASSWORD,
                                            "data-test-id": "loginForm_forgotButton",
                                            children: "Forgot password?"
                                        })
                                    }),
                                    error && errorForMissingOrInvalid2FACode(error) && /*#__PURE__*/ (0,jsx_runtime.jsx)(input_field/* default */.Z, {
                                        size: "regular",
                                        name: "code",
                                        label: "Code",
                                        id: "code",
                                        autoComplete: "off",
                                        required: true
                                    }),
                                    isCaptchaRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "LoginForm__captchaWrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                            ref: recaptchaRef,
                                            sitekey: appConfig/* appConfig.CAPTCHA_KEY */.eG.CAPTCHA_KEY,
                                            onChange: onCaptchaChange
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                                        children: error && !errorForMissing2FACode(error) && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            className: "LoginForm__errorMessageWrapper"
                                        }, appConfig/* animatePresenceConfig */.Rr), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* MessageBox */._, {
                                                children: error.message
                                            })
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                        "data-test-id": "loginForm_submit",
                                        type: "submit",
                                        size: "large",
                                        variant: "primary",
                                        fullWidth: true,
                                        children: "Continue"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                                children: loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    className: "Login__paper__loadingOverlay"
                                }, appConfig/* animatePresenceConfig */.Rr), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "Login__footer__requestPlatformLogin",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Don't have an account?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: linksConstants/* linksConstants.CONTACT */.s.CONTACT,
                                "data-test-id": "loginForm_contact_link",
                                children: "Contact Us"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Login__footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPageFooter/* AuthPageFooter */.G, {})
            })
        ]
    });
};
function errorForMissing2FACode(error) {
    return error.status === 422 && error.message === "Two-factor authentication needed";
}
function errorForMissingOrInvalid2FACode(error) {
    return errorForMissing2FACode(error) || error.status === 422 && error.message === "Invalid code";
}

// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/redux/Provider.js
var Provider = __webpack_require__(66884);
;// CONCATENATED MODULE: ./pages/login.jsx




var LoginPage = function(param) {
    var initialReduxState = param.initialReduxState;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Provider/* default.Redux */.Z.Redux, {
        initialReduxState: initialReduxState,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/login",
                title: "Log In",
                description: "Log in to your Demyst Platform account by entering your email and password."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {})
        ]
    });
};
/* harmony default export */ var login = (LoginPage);


/***/ }),

/***/ 5786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2777);




var Loader = function(param) {
    var className = param.className, _fullHeight = param.fullHeight, fullHeight = _fullHeight === void 0 ? false : _fullHeight, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _withPadding = param.withPadding, withPadding = _withPadding === void 0 ? false : _withPadding;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Loader", fullHeight && "Loader--fullHeight", fullWidth && "Loader--fullWidth", withPadding && "Loader--withPadding", className),
        role: "progressbar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_2__/* .FiLoader */ .dAq, {})
    });
};
Loader.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.string,
    fullHeight: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool,
    fullWidth: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool,
    withPadding: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool
};


/***/ }),

/***/ 52696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ AuthPageHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71571);
/* harmony import */ var _assets_svg_DemystLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45911);




var AuthPageHeader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: "AuthPageHeader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            "aria-label": "Demyst logo",
            href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_2__/* .linksConstants.HOME */ .s.HOME,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svg_DemystLogo__WEBPACK_IMPORTED_MODULE_3__/* .DemystLogo */ .w, {})
        })
    });
};


/***/ }),

/***/ 27832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ UserUnlockedBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var UserUnlockedBox = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "UserUnlockedBox",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "MarginLeft20",
            children: text
        })
    });
};


/***/ }),

/***/ 74918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ userSelectors; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var isUserLoggedIn = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.isUserLoggedIn;
}, function(isUserLoggedIn) {
    return isUserLoggedIn;
});
var getUserData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.userData;
}, function(userData) {
    return userData;
});
var getUserPermissions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    var ref, ref1;
    return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.permissions;
}, function(permissions) {
    return permissions;
});
var getBlackfinJWT = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.blackfinJWT;
}, function(blackfinJWT) {
    return blackfinJWT;
});
var getContactUsModalState = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.contactUsModalOpen;
}, function(contactUsModalOpen) {
    return contactUsModalOpen;
});
var isAdmin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    var ref, ref1;
    return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.permissions;
}, function(permissions) {
    return (permissions === null || permissions === void 0 ? void 0 : permissions.can_show_admin) === true;
});
var getUserPlan = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    var ref, ref1;
    return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.organization) === null || ref1 === void 0 ? void 0 : ref1.formatted_plan;
}, function(formatted_plan) {
    return formatted_plan;
});
var isUserDataFetching = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.isUserDataFetching;
}, function(isUserDataFetching) {
    return isUserDataFetching;
});
var isTosOutdated = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    function(state) {
        return state.user.isUserLoggedIn;
    },
    function(state) {
        return state.user.userData;
    }
], function(isUserLoggedIn, userData) {
    var ref;
    return isUserLoggedIn && (userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.tos_outdated);
});
var hasUserBeenLoggedOutManually = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasBeenLoggedOutManually;
}, function(hasBeenLoggedOutManually) {
    return hasBeenLoggedOutManually;
});
var hasNewOrOneTrueCreditsEnabled = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    function(state) {
        var ref, ref1;
        return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.organization) === null || ref1 === void 0 ? void 0 : ref1.credits_or_caps;
    },
    function(state) {
        var ref, ref1;
        return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.permissions;
    }, 
], function(creditsOrCaps, permissions) {
    return creditsOrCaps === "new_credits" || creditsOrCaps === "one_credit_to_rule_them_all" || [
        "demyst_admin",
        "demyst_admin_org_edit",
        "demyst_client"
    ].some(function(p) {
        return (permissions || {})[p];
    });
});
var lastLoggedOutPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.lastLoggedOutPage;
}, function(lastLoggedOutPage) {
    return lastLoggedOutPage;
});
var hasSigned = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasSigned;
}, function(hasSigned) {
    return hasSigned;
});
var hasProvidedBilling = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasProvidedBilling;
}, function(hasProvidedBilling) {
    return hasProvidedBilling;
});
var hasRequestedAgreement = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasRequestedAgreement;
}, function(hasRequestedAgreement) {
    return hasRequestedAgreement;
});
var hasApproval = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasApproval;
}, function(hasApproval) {
    return hasApproval;
});
var userSelectors = {
    isAdmin: isAdmin,
    isUserLoggedIn: isUserLoggedIn,
    getUserData: getUserData,
    isUserDataFetching: isUserDataFetching,
    getUserPermissions: getUserPermissions,
    isTosOutdated: isTosOutdated,
    getBlackfinJWT: getBlackfinJWT,
    getContactUsModalState: getContactUsModalState,
    getUserPlan: getUserPlan,
    hasUserBeenLoggedOutManually: hasUserBeenLoggedOutManually,
    hasNewOrOneTrueCreditsEnabled: hasNewOrOneTrueCreditsEnabled,
    lastLoggedOutPage: lastLoggedOutPage,
    hasSigned: hasSigned,
    hasProvidedBilling: hasProvidedBilling,
    hasRequestedAgreement: hasRequestedAgreement,
    hasApproval: hasApproval
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,8278,9440,319,7467,9774,2888,179], function() { return __webpack_exec__(10545); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);